import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import PointRequiredSection from 'component/campaign/PointRequiredSection';
import PickupStore from 'component/coupon/PickUpStoreSection';

import { createAction } from 'utils';
import {
  CouponSelectionType,
  CustomerSelectionBehavior,
} from 'utils/CustomEnums';

import './BuyCouponModal.scss';

@connect(({ campaignDetail, store, myCoupon }) => ({
  ...campaignDetail,
  campaignStores: store.campaignStore,
  selectedStore: myCoupon.selectedStore,
  selectedUsageMedium: myCoupon.selectedUsageMedium,
  applicableStoreIsLoading: store.loadingApplicableStores,
}))
class BuyCouponModal extends Component {
  componentDidMount() {
    this.props.dispatch(
      createAction('campaignDetail/getCampaignDetail')({
        campaignID: this.props.campaignID,
      }),
    );
    this.props.dispatch(
      createAction('store/getCampaignStores')({
        campaignId: this.props.campaignID,
      }),
    );
  }

  componentWillUnmount() {}

  render() {
    const campaignData = this.props?.[this.props.campaignID]?.data || {};

    const coupon = campaignData?.coupon ?? {};
    const stores = this.props.campaignStores;
    let couponSelectionType = null;
    const {
      customerStoreSelectionBehavior,
      customerOnlineOfflineSelectionBehavior,
    } = coupon;
    const showStoreSelection = [
      CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
      CustomerSelectionBehavior.NO_LIMIT,
    ].includes(customerStoreSelectionBehavior);
    const hasStore = showStoreSelection && stores && stores.length > 0;
    if (showStoreSelection) {
      if (
        customerStoreSelectionBehavior === CustomerSelectionBehavior.NO_LIMIT
      ) {
        couponSelectionType = CouponSelectionType.VIRTUAL_STORE;
      } else {
        couponSelectionType = CouponSelectionType.STORE;
      }
    }
    const showMediumSelection = [
      CustomerSelectionBehavior.SELECT_WHEN_ACQUIRE,
      CustomerSelectionBehavior.NO_LIMIT,
    ].includes(customerOnlineOfflineSelectionBehavior);
    if (showMediumSelection) {
      if (
        customerOnlineOfflineSelectionBehavior ===
        CustomerSelectionBehavior.NO_LIMIT
      ) {
        couponSelectionType = CouponSelectionType.VIRTUAL_ONLINE_OFFLINE;
      } else {
        couponSelectionType = CouponSelectionType.ONLINE_OFFLINE;
      }
    }
    return (
      <Modal
        show={this.props.show || false}
        className={'buy-coupon-modal'}
        onHide={
          this.props.onHide ||
          (() => {
            this.props.onHide();
          })
        }
        scrollable={false}
      >
        <div>
          {hasStore || showMediumSelection ? (
            <PickupStore
              defaultSelectedFirst={true}
              stores={stores}
              applicableStoreIsLoading={this.props.applicableStoreIsLoading}
              couponSelectionType={couponSelectionType}
              isCampaignBuyCoupon={true}
            />
          ) : null}
          <PointRequiredSection
            coupon={coupon}
            hasStore={hasStore}
            selectedStore={this.props.selectedStore}
            hasUsageMedium={showMediumSelection}
            selectedUsageMedium={this.props.selectedUsageMedium}
            campaignID={this.props.campaignID}
            onClickSuccessBtn={() => {
              this.props.onHide();
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default BuyCouponModal;
